<div class="short-message-threads">
    <div class="content">
        <div class="button-group">
            <button class="secondary-button" data-automation-id="short-message-threads-update-button"
                (click)="refreshThreads()" [disabled]="noFilesProjectData()">
                <i class="fa fa-refresh update-button-icon"></i>
                <span>Update All Threads</span>
            </button>
        </div>
        <res-document-list #shortMessageGrid [responseCallback]="responseCallback"
            [gridPagerCustomCallback]="gridPagerCustomCallback"></res-document-list>
    </div>
</div>